import { ModalGeneric } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';

import ProgramPointList from '../../../../WorkReportModals/ProgramPointModal/ProgramPointList/ProgramPointList';
import { aprobador } from '../../../../../security/constantsRols';
import { checkRol } from '../../../../../security';
import useLocationProgramPoints from '../../../../WorkReportModals/ProgramPointModal/useLocationProgramPoints';

export const validationSchemaAprroval = Yup.object().shape({
  programPoints: Yup.array().of(
    Yup.object().shape({
      quantity: Yup.string().required('La cantidad es requerida'),
      points: Yup.string(),
      idPartePuntoPrograma: Yup.number().nullable(),
      idParteDiario: Yup.number().nullable(),
      subCode: Yup.object().required('El subcódigo es requerido'),
      code: Yup.object().required('El código es requerido'),
      cost: Yup.object().required('El costo es requerido'),
      clasification: Yup.string().required('La clasificación es requerida')
    })
  ),
  totalValue: Yup.number().required('El valor total es requerido')
});

const hasInvalidProgramPoint = (programPoint) =>
  programPoint?.code === null ||
  programPoint?.code === '' ||
  programPoint?.subCode === null ||
  programPoint?.subCode === '' ||
  programPoint?.cost === null ||
  programPoint?.cost === '' ||
  programPoint?.cost?.nombre === '' ||
  programPoint?.code?.nombre === '' ||
  programPoint?.subCode?.nombre === '' ||
  programPoint?.clasification === null ||
  programPoint?.clasification === '';

const ModalProgramPointApproval = ({ show, onHide, ...props }) => {
  const { line, dateSelect, fetchData, editCSA, daily } = props;

  const {
    values,
    loading,
    setFieldValue,
    resetForm,
    getProgramPointsData,
    approveLocationProgramPoints
  } = useLocationProgramPoints({
    line
  });

  const [disablePrimaryAction, setDisablePrimaryAction] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const isApprover = checkRol(aprobador);

  const onExit = () => {
    onHide();
    fetchData();
    resetForm();
  };

  const hasRequiredProperties = (PP) =>
    Object.prototype.hasOwnProperty.call(PP, 'code') &&
    Object.prototype.hasOwnProperty.call(PP, 'subCode') &&
    Object.prototype.hasOwnProperty.call(PP, 'cost');
  // comentado parcialmente
  // Object.prototype.hasOwnProperty.call(PP, 'clasification');

  // Validate programPoints according to business rules
  const isProgramPointComplete = (pp, index, arrayLength) => {
    // If there is only one row: all required fields except points
    if (arrayLength === 1) {
      return pp.quantity !== '' && pp.quantity !== null;
    }
    // If there is more than one row:
    if (index === 0) {
      // First row: all required fields (including points)
      return pp.quantity !== '' && pp.quantity !== null && pp.points !== '' && pp.points !== null;
    }

    // From the second row onward: quantity and points are mandatory
    return pp.quantity !== '' && pp.quantity !== null && pp.points !== '' && pp.points !== null;
  };

  useEffect(() => {
    const hasCompleteData = values.locations.every((location) =>
      location.programPoints.every(hasRequiredProperties)
    );

    const allProgramPointsComplete = values.locations
      .filter((location) => location?.habilitaVentana)
      .every((location) =>
        location.programPoints.every((pp, index) =>
          isProgramPointComplete(pp, index, location.programPoints.length)
        )
      );

    const hasInvalidProgramPointData = values.locations.some((location) =>
      location.programPoints.some(hasInvalidProgramPoint)
    );

    setDisablePrimaryAction(!allProgramPointsComplete);

    if (hasCompleteData) {
      setShowAlert(hasInvalidProgramPointData);
    } else {
      setShowAlert(true);
    }
  }, [values.locations]);

  useEffect(() => {
    if (show) getProgramPointsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handlePostProgramPoints = async () => {
    await approveLocationProgramPoints(values?.locations);
    onExit();
  };

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onExit}
      primaryAction={() => {
        handlePostProgramPoints();
      }}
      primaryActionDisabled={isApprover && disablePrimaryAction}
      primaryActionLabel="Confirmar Aprobación"
      secondaryAction={onExit}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title="Datos operativos"
    >
      <ProgramPointList
        disabledInputPP
        disabledInputQuantity
        displayButtons={false}
        displayFixedlabel={false}
        editCSA={editCSA}
        eventoSigla={line?.eventoSigla}
        idParteDiario={line?.idParteDiario}
        isLocation
        line={line}
        loading={loading}
        // quantityTotalReturn={quantityTotalReturn}
        selectedDate={dateSelect}
        setFieldValue={setFieldValue}
        showAlert={showAlert}
        showTitle
        showWarningOperationalData
        tipoAsignacion={daily?.tipoAsignacion}
        values={values}
        viewCSA
      />
    </ModalGeneric>
  );
};

export default ModalProgramPointApproval;

ModalProgramPointApproval.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  line: PropTypes.shape({
    idParteDiario: PropTypes.number,
    tienePuntosPrograma: PropTypes.bool,
    cantidad: PropTypes.string,
    eventoSigla: PropTypes.string
  }).isRequired,
  dateSelect: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  viewCSA: PropTypes.bool,
  editCSA: PropTypes.bool,
  daily: PropTypes.shape({
    tipoAsignacion: PropTypes.number,
    variosValoresOperativos: PropTypes.bool,
    codigoOperativo: PropTypes.string,
    numeroContrato: PropTypes.number,
    posicionSap: PropTypes.string,
    lineaSap: PropTypes.string,
    cantidad: PropTypes.string
  }).isRequired
};

ModalProgramPointApproval.defaultProps = {
  viewCSA: false,
  editCSA: false
};
